import helpers from '../../utils/helpers';
import framesProcessingService from '../device/framesProcessingService';
// import deviceConnectionDetectorService from '../deviceConnectionDetectorService';
import {createError} from '../errors/errorService';
import {MW_ERRORS} from '../../consts/app/mwErrors';
// import ReconnectEventEmitter from '../events/reconnectEventEmitter';
// import iotService from '../iot/iotService';
import {log} from '../log';
import pairingService from '../pairingService';
import IqosBleClient from './iqosBleClient';
import {initConnection, onConnectionChange} from '../device/connectionService';
import {getPairingDelay} from './iqosBlePairingDelayService';
import deviceConnectionStatusTypes from '../../consts/device/deviceConnectionStatusTypes';

const DEVICE_REQUEST_TIMEOUT_MS = 10 * 1000;

const connect = async ({
    isNewDevice,
    onDeviceInitialization,
    onDeviceSelect,
    retryNumber,
    isPairingDelayOnWindowsEnabled,
}) => {
    let deviceSelectTimeout;
    let timeoutResolve;
    let timeoutReject;

    const options = {
        onDeviceConnect: async () => {
            framesProcessingService.createNew();

            const data = await initConnection({});

            onConnectionChange(deviceConnectionStatusTypes.CONNECTED);
            onDeviceInitialization(data);
        },
        onDisconnected: (isForceDisconnected) => {
            pairingService.onDeviceDisconnect(isForceDisconnected);

            onConnectionChange(
                isForceDisconnected
                    ? deviceConnectionStatusTypes.DISCONNECTED
                    : deviceConnectionStatusTypes.DISCONNECTED_WITH_RECONNECT
            );
        },
        onForcedDisconnect: () => {
            onConnectionChange(deviceConnectionStatusTypes.DISCONNECTED);
            // pairingService.disconnectAndForwardToMyDevicesPage();
        },
        onDeviceReconnectSuccess: () => {
            onConnectionChange(deviceConnectionStatusTypes.CONNECTED);

            // const reconnectEventEmitter = new ReconnectEventEmitter();
            // reconnectEventEmitter.emitReconnect();
            initConnection({isReconnect: true, throwException: false});
        },
        onReconnectFail: () => {
            // deviceConnectionDetectorService.showFailedReconnectDeviceGuide({isReconnectFailed: true});
        },
        onDeviceSelect: (deviceName) => {
            onDeviceSelect?.(deviceName);

            // Start timeout when device is selected
            deviceSelectTimeout = setTimeout(() => {
                if (timeoutReject) {
                    timeoutReject(createError(MW_ERRORS.ERROR_CONNECTION_NOT_FOUND, 'Device request timeout error'));
                }
            }, DEVICE_REQUEST_TIMEOUT_MS);
        },
        onFinishDeviceSelect: () => {
            clearTimeout(deviceSelectTimeout);
            if (timeoutResolve) {
                timeoutResolve();
            }
        },
    };

    // Create timeout promise that can be controlled by callbacks
    const timeoutPromise = new Promise((resolve, reject) => {
        timeoutResolve = resolve;
        timeoutReject = reject;
    });

    const iqosBleClient = new IqosBleClient(options);

    // Race between device connection and timeout
    await Promise.race([
        await iqosBleClient.connect({
            isNewDevice,
            onReadingCharacteristics: (deviceName) =>
                onReadingCharacteristics({deviceName, retryNumber, isPairingDelayOnWindowsEnabled}),
        }),
        await timeoutPromise,
    ]);
};

const onReadingCharacteristics = async ({deviceName, retryNumber, isPairingDelayOnWindowsEnabled}) => {
    const delay = getPairingDelay({deviceName, retryNumber, isPairingDelayOnWindowsEnabled});

    await helpers.timeout(delay);
};

const isClientInitialized = () => {
    try {
        new IqosBleClient();

        return true;
    } catch (e) {
        return false;
    }
};

const disconnect = () => {
    try {
        const iqosBleClient = new IqosBleClient();

        iqosBleClient.disconnect();
        iqosBleClient.destroy();
    } catch (e) {
        log.info(`iqosBleService: disconnect() error: ${e}`);
    }
};

const isDeviceConnected = () => {
    try {
        const iqosBleClient = new IqosBleClient();

        return iqosBleClient.isDeviceConnected();
    } catch (e) {
        log.debug(`iqosBleService: isDeviceConnected() error: ${e}`);

        return false;
    }
};

const unmount = () => {
    try {
        const iqosBleClient = new IqosBleClient();

        iqosBleClient.unmount();
    } catch (e) {
        log.info(`iqosBleService: unmount() error: ${e}`);
    }
};

export default {
    connect,
    disconnect,
    isClientInitialized,
    isDeviceConnected,
    unmount,
};
